import { ComponentProps, useState } from "react";
import { OverrideRecipeDialog } from "./OverrideRecipeDialog";

type Props = ComponentProps<typeof OverrideRecipeDialog>;
type Session = Pick<Props, "floorRecipe" | "selectedHeats" | "steelGrade">;

export const OverrideRecipeModal = (props: Props) => {
  const [session, setSession] = useState<Session | null>(null);

  if (props.open && session === null) {
    setSession({
      floorRecipe: props.floorRecipe,
      selectedHeats: props.selectedHeats,
      steelGrade: props.steelGrade,
    });
  } else if (!props.open && session !== null) {
    setSession(null);
  }

  return props.open && session !== null ? (
    <OverrideRecipeDialog {...props} {...session} />
  ) : null;
};
